/**
 * Shared Swiper config.
 */
import { SwiperInit } from './swiper-init';

document.addEventListener('DOMContentLoaded', () => {
	const containers = document.querySelectorAll('.rlt-our-vision .swiper');

	if (!containers.length) {
		return;
	}

	containers.forEach((element) => {
		SwiperInit(element);
	});
});
